import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { FormattedMessage } from 'react-intl'

import './progetto.sass'

export default class ProgettoPage extends Component {
  render() {
    const {
      testoInEvidenza,
      testo,
      sottotitolo,
    } = this.props.data.datoCmsPaginaProgetto

    return (
      <div className="wrap-narrower">
        <Helmet>
          <title>Progetto | {this.props.data.site.siteMetadata.title}</title>
        </Helmet>

        <h1 className="text-primary mb-3">
          <FormattedMessage id="menu.heading.firstLine" />
          <br />
          <FormattedMessage id="menu.heading.secondLine" />
        </h1>

        <div
          className="mb-3 text-bold"
          dangerouslySetInnerHTML={{
            __html: sottotitolo.replace(/\n\n/g, '<br />'),
          }}
        >
          {/* <p className="mt-0 mb-04">progetto FNS</p>
          <p className="mt-0 mb-04">
            Responsabile scientifico: Nicola Navone, AdM - USI
          </p>
          <p className="mt-0 mb-04">
            Ricercatori: Orietta Lanzarini, Matteo Iannello, Ilaria Giannetti
          </p> */}
        </div>

        <h2
          className="Progetto__Abstract text-primary"
          dangerouslySetInnerHTML={{ __html: testoInEvidenza }}
        />

        <div
          className="text-size-1-2"
          dangerouslySetInnerHTML={{ __html: testo }}
        />
      </div>
    )
  }
}

export const query = graphql`
  query Progetto($locale: String!) {
    site {
      siteMetadata {
        title
      }
    }
    datoCmsPaginaProgetto(locale: { eq: $locale }) {
      testoInEvidenza
      testo
      sottotitolo
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/progetto.js